import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinindia() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in India',
    heading: 'Aaryan Travels: Corporate Cab Services in India',
    headingDescription: ' Aaryan Travels provides professional Corporate Cab Services in India, offering reliable transportation solutions for businesses, executives, and corporate teams across major cities including Pune, Mumbai, Bangalore, Hyderabad, Chennai, Delhi, and Ahmedabad. Whether you need daily employee commute, client pickup, airport transfers, or intercity travel for meetings and factory visits, our fleet of sedans, SUVs, luxury cars, and tempo travellers ensures top-notch comfort and punctuality. With uniformed chauffeurs, GPS-enabled vehicles, monthly rental plans, and centralized billing, we deliver seamless corporate mobility across India. From IT hubs to industrial zones, Aaryan Travels is the trusted partner for nationwide corporate cab services with 24/7 operational support.',

    top: 'Top Places to Visit in India with Aaryan Travels',

"topPlaces": [
  {
    "title": "Taj Mahal, Agra",
    "description": "The Taj Mahal is one of the Seven Wonders of the World, built in the 17th century by Mughal Emperor Shah Jahan in memory of his beloved wife Mumtaz Mahal. Made entirely of white marble, it changes color with the sunlight—pinkish morning glow, golden at sunset, and majestic moonlit nights. Its symmetry, calligraphy, and intricate inlay work mesmerize visitors. The Taj Mahal is India’s eternal symbol of love."
  },
  {
    "title": "Jaipur City Palace, Rajasthan",
    "description": "Located in the heart of Jaipur, City Palace is a grand blend of Rajput and Mughal architecture. With courtyards, museums, royal chambers, and the iconic Peacock Gate, it showcases the opulence of the royal family. The palace still serves as a residence for Jaipur’s royals. Colorful artifacts, armoury, and frescoed walls enchant tourists. City Palace is India’s regal heritage preserved with pride."
  },
  {
    "title": "Varanasi Ghats, Uttar Pradesh",
    "description": "Varanasi, one of the world’s oldest living cities, is known for its sacred ghats along the Ganga River. Pilgrims perform rituals, offer prayers, and take holy dips to purify their souls. The evening Ganga Aarti with lamps and chanting is a magical sight. The narrow streets, temples, and spiritual aura attract seekers from across the globe. Varanasi is India’s timeless spiritual capital."
  },
  {
    "title": "Backwaters of Kerala, Alleppey",
    "description": "The Kerala Backwaters offer a peaceful escape through interconnected canals, lagoons, and lakes surrounded by coconut palms. Tourists enjoy houseboat cruises gliding over still waters with reflections of village life. Traditional meals served on banana leaves enhance the charm. Sunsets over the paddy fields are mesmerizing. The backwaters are India’s floating paradise of tranquility."
  },
  {
    "title": "Golden Temple, Amritsar",
    "description": "The Golden Temple, also known as Harmandir Sahib, is the holiest shrine of Sikhism. Its gold-plated dome reflects in the calm waters of the sacred sarovar. The Langar Hall serves free meals to thousands daily, symbolizing equality and service. The calming prayers and illuminated night view leave visitors speechless. The Golden Temple is India’s beacon of unity and devotion."
  },
  {
    "title": "Hampi Ruins, Karnataka",
    "description": "Hampi, a UNESCO World Heritage Site, was once the capital of the Vijayanagara Empire. Its surreal landscape of ancient stone temples, boulder hills, and carved chariots feels like an open-air museum. The iconic Stone Chariot and Vittala Temple stand as engineering marvels. Adventure seekers also explore by cycle or cliff trails. Hampi is India’s mystical blend of architecture and adventure."
  },
  {
    "title": "Gateway of India, Mumbai",
    "description": "Built in 1924 facing the Arabian Sea, the Gateway of India is Mumbai’s grand arch monument symbolizing colonial heritage. Tourists enjoy boat rides to Elephanta Caves and scenic photos along the promenade. The structure glows beautifully at night, surrounded by local vendors and travelers. The Gateway of India is India’s coastal emblem of pride."
  },
  {
    "title": "Mysore Palace, Karnataka",
    "description": "Mysore Palace is a stunning royal residence featuring Indo-Saracenic architecture with stained glass, domes, and detailed carvings. Lit up with 97,000 bulbs every Sunday, it transforms into a glowing marvel. The interiors showcase royal thrones, jewelry, and artwork. The Dasara festival brings grandeur with processions and cultural shows. Mysore Palace is India’s illuminated royal wonder."
  },
  {
    "title": "Rann of Kutch, Gujarat",
    "description": "The Great Rann of Kutch is a vast white salt desert that shines under moonlight, creating an ethereal glow. During the Rann Utsav festival, traditional huts, folk dances, and camel rides attract thousands. Visitors stay in tents and enjoy moonlit walks across the salt plains. The Rann is India’s magical white desert of celebration."
  },
  {
    "title": "Andaman & Nicobar Islands",
    "description": "The Andaman Islands are known for their crystal-clear beaches, coral reefs, and water sports like snorkeling and scuba diving. Radhanagar Beach on Havelock Island is ranked among the world’s best. Cellular Jail adds historical depth with its light and sound show. Dense tropical forests and turquoise waters offer paradise-like beauty. Andaman is India’s tropical escape to serenity."
  }
],


"services": [
  {
    "name": "Corporate Cab Services in India",
    "description": "Our Corporate Cab Services across India are designed to meet the complex transportation needs of businesses, offering seamless, reliable, and professional travel solutions. Whether for daily employee commutes, executive transfers, or intercity business travel, we provide a nationwide network of vehicles equipped with modern amenities and skilled chauffeurs. Our service emphasizes punctuality, safety, and confidentiality, making it ideal for organizations seeking hassle-free corporate mobility at competitive rates."
  },
  {
    "name": "Business Taxi Services India",
    "description": "Business Taxi Services India caters exclusively to corporate clients who require flexible and efficient transport options across cities and states. We specialize in accommodating last-minute travel requests, airport pickups, and inter-office transfers with a strong focus on professionalism and customer satisfaction. Our fleet includes premium sedans, SUVs, and luxury cars maintained to the highest standards, ensuring your team travels comfortably and arrives on time for all crucial meetings and events."
  },
  {
    "name": "PAN India Corporate Cab",
    "description": "Experience truly pan-India corporate cab services with coverage spanning metro cities, tier-2 towns, and industrial hubs. Our comprehensive network ensures that businesses with branches nationwide can count on consistent and top-quality transportation solutions. From regular office commutes to long-distance business trips, our PAN India service guarantees well-maintained vehicles, verified drivers, and tailored packages that fit your company’s unique travel needs."
  },
  {
    "name": "Employee Transport India",
    "description": "Employee Transport India offers safe, punctual, and cost-effective commuting solutions for companies of all sizes. Our services are designed to handle large-scale daily employee transportation with efficiency and care, ensuring smooth pick-ups and drop-offs that respect employees' time. Equipped with GPS tracking and real-time updates, our service helps businesses enhance workforce productivity by reducing commute-related stress and delays."
  },
  {
    "name": "Chauffeur Services for Business India",
    "description": "Our Chauffeur Services for Business India provide experienced, professional drivers trained in corporate etiquette and route optimization. Whether you need chauffeurs for VIP clients, executives, or employee transport, we offer personalized services tailored to match your company’s standards. Drivers are background-verified, knowledgeable about local and intercity routes, and committed to delivering a comfortable, discreet, and punctual travel experience across the country."
  },
  {
    "name": "Long-Term Corporate Cab India",
    "description": "Opt for Long-Term Corporate Cab rentals with flexible contracts across India that help reduce operational costs while ensuring consistent, quality transportation. Ideal for companies looking to secure reliable cabs for weeks or months, our service includes customizable plans with monthly billing, priority booking, and dedicated support teams. This long-term solution suits businesses aiming to streamline travel management for their workforce or visiting clients."
  },
  {
    "name": "Monthly Business Taxi India",
    "description": "Our Monthly Business Taxi service across India offers subscription-based cab rentals tailored to meet your ongoing corporate travel demands. With fixed monthly rates, priority access to premium vehicles, and easy online management, companies can ensure uninterrupted transportation for executives, employees, and guests. The service is ideal for reducing travel expenses while maintaining high standards of comfort, safety, and reliability throughout the month."
  },
  {
    "name": "Office Cab Hire India",
    "description": "Office Cab Hire India specializes in providing dedicated vehicles for daily office commutes, ensuring your employees arrive on time and stress-free. With options ranging from shared rides to exclusive vehicles, this service is scalable according to your workforce size and geographical spread. Equipped with modern safety features and real-time tracking, our office cab service promotes punctuality, employee satisfaction, and operational efficiency."
  },
  {
    "name": "Affordable Corporate Taxi India",
    "description": "Affordable Corporate Taxi India offers cost-effective transportation solutions without compromising on quality or comfort. Perfect for startups, SMEs, and large corporations alike, this service provides budget-friendly rates combined with reliable service, well-maintained vehicles, and verified drivers. Flexible plans and transparent pricing models ensure you can scale your travel needs economically across cities nationwide."
  },
  {
    "name": "Executive Car Rentals India",
    "description": "Our Executive Car Rentals India service caters to corporate executives and business travelers who demand sophistication, comfort, and professionalism. Featuring luxury sedans and premium SUVs, this service provides chauffeur-driven vehicles that are impeccably maintained and equipped with all modern amenities. Perfect for client meetings, airport transfers, and important events, our executive rentals elevate your corporate travel experience."
  },
  {
    "name": "Best Corporate Cabs India",
    "description": "Recognized as one of the Best Corporate Cabs providers in India, we prioritize reliability, punctuality, and exceptional customer service. Our expansive fleet, experienced drivers, and technology-driven booking systems set us apart in the corporate transportation sector. Whether for daily office commutes or specialized business trips, we guarantee a seamless, comfortable journey tailored to your company’s specific requirements."
  },
  {
    "name": "Company Taxi India",
    "description": "Company Taxi India provides dedicated taxi services for businesses requiring flexible and scalable transportation solutions. Our service supports everything from small teams to large enterprises, ensuring safe and timely travel for employees, clients, and visitors. With easy online booking, real-time tracking, and responsive customer support, we simplify corporate travel management across multiple locations."
  },
  {
    "name": "Enterprise Cab India",
    "description": "Enterprise Cab India offers large-scale corporate transport services designed for enterprises with extensive mobility needs. From managing employee shuttles to handling client transfers and event transportation, our service focuses on operational efficiency, safety, and convenience. We work closely with your organization to deliver customized fleet management solutions and seamless integration with your travel policies."
  },
  {
    "name": "Corporate Fleet Services India",
    "description": "Our Corporate Fleet Services India provide companies with end-to-end management of their vehicle fleets, including maintenance, driver management, and route optimization. Designed for businesses looking to outsource their transportation logistics, this service improves cost-efficiency and operational transparency. With advanced tracking and reporting tools, companies can monitor usage, ensure compliance, and maintain high service standards across all locations."
  },
  {
    "name": "Staff Cab Booking India",
    "description": "Staff Cab Booking India simplifies the process of arranging reliable and timely transportation for your employees. From bulk bookings to customized schedules, our service caters to varied workforce requirements, ensuring employees have a safe and comfortable commute. Our dedicated customer service team supports seamless booking modifications, cancellations, and route planning to adapt to your company’s dynamic needs."
  }
],
"tableData": [
  ["Corporate Cab Services in India", "Business Taxi Services India"],
  ["PAN India Corporate Cab", "Employee Transport India"],
  ["Chauffeur Services for Business India", "Long-Term Corporate Cab India"],
  ["Monthly Business Taxi India", "Office Cab Hire India"],
  ["Affordable Corporate Taxi India", "Executive Car Rentals India"],
  ["Best Corporate Cabs India", "Company Taxi India"],
  ["Enterprise Cab India", "Corporate Fleet Services India"],
  ["Staff Cab Booking India", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Nationwide Corporate Cab Services Across India",
    "WhyChoosedescription": "Aaryan Travels provides reliable and professional corporate cab services covering major cities and business hubs across India."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop at Your Desired Location",
    "WhyChoosedescription": "Ensure timely and hassle-free commutes for your employees and clients anywhere in India."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Business-Class Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars designed to provide comfort and professionalism throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Key Corporate Routes",
    "WhyChoosedescription": "Our drivers have extensive knowledge of major business districts and routes across Indian cities."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing with No Hidden Charges",
    "WhyChoosedescription": "Get clear, GST-compliant invoices and upfront pricing with no surprise costs."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Business Travel Needs",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, scheduling, and travel coordination."
  },
  {
    "WhyChooseheading": "Flexible Contract Options: Daily, Weekly, or Monthly",
    "WhyChoosedescription": "Choose short-term or long-term cab hire contracts customized to your organization’s requirements."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Corporate Requirement",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers based on your team size and travel preferences."
  }
]

























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services across India?',
    answer: 'Yes, Aaryan Travels provides professional and reliable corporate cab services throughout India, catering to diverse business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in India with Aaryan Travels?',
    answer: 'You can book corporate cabs across India through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in India?',
    answer: 'Aaryan Travels offers a wide fleet including sedans, SUVs, and premium cars suitable for executive and employee transportation anywhere in India.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute across India?',
    answer: 'Yes, we provide customized corporate cab solutions for daily employee pickups and drops in multiple cities across India.',
  },
  {
    question: 'Are drivers experienced and trained for corporate travel requirements in India?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with routes and corporate standards throughout India.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group cab bookings for corporate events across India?',
    answer: 'Yes, we specialize in managing group transportation and bulk cab bookings for corporate meetings, events, and conferences nationwide.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for corporate cab services in India?',
    answer: 'Yes, we provide flexible billing options including monthly invoicing for our corporate clients anywhere in India.',
  },
  {
    question: 'Is your corporate cab service available 24x7 across India?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services to ensure seamless business travel across India.',
  },
  {
    question: 'What safety measures are in place for corporate cab services in India?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols nationwide.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings anywhere in India?',
    answer: 'Yes, we allow full customization of pickup and drop points based on your corporate travel requirements throughout India.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vikram Singh',
    feedback: 'Aaryan Travels’ corporate cab services across India have been consistently professional and reliable for our nationwide offices.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Sharma',
    feedback: 'Excellent corporate cab support by Aaryan Travels throughout India. Their services make business travel effortless.',
    rating: 5,
  },
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in India",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-india.jpg", // replace with actual image URL
  "description": "Pan-India corporate cab services by Aaryan Travels offering reliable and affordable business taxi solutions. Perfect for employee transport, office hires, and executive car rentals across India.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update if needed
    "ratingCount": "3000", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-india"
  }
};






  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in India | PAN India Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Pan-India corporate cab services by Aaryan Travels offering reliable and affordable business taxi solutions. Perfect for employee transport, office hires, and executive car rentals across India."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in India, Business Taxi Services India, PAN India Corporate Cab, Employee Transport India, Chauffeur Services for Business India, Long-Term Corporate Cab India, Monthly Business Taxi India, Office Cab Hire India, Affordable Corporate Taxi India, Executive Car Rentals India, Best Corporate Cabs India, Company Taxi India, Enterprise Cab India, Corporate Fleet Services India, Staff Cab Booking India"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinindia;